import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ projectRole }) => <>{projectRole?.name}</>;

  return (
    <BulkActionModal
      title="Delete Project Roles"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .projectRoles()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected project role' : `the ${ids.length} selected project roles`
      }. Roles that are in use will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
